import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -100, // it overshoots sometimes
  cancelable: false, //otherwise can't work with tap
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
